// components/regional/RegionalAnalytics.jsx
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { AlertCircle, Globe } from 'lucide-react';

const RegionalAnalytics = () => {
    // Placeholder data
    const data = [
        { region: 'North America', sales: 4500, revenue: 89600, avgPrice: 19.99 },
        { region: 'Europe', sales: 3800, revenue: 72200, avgPrice: 18.99 },
        { region: 'Asia', sales: 6200, revenue: 93000, avgPrice: 14.99 },
        { region: 'South America', sales: 1200, revenue: 15600, avgPrice: 12.99 },
        { region: 'Oceania', sales: 800, revenue: 15200, avgPrice: 18.99 },
    ];

    return (
        <div className="p-8">
            <div className="mb-6">
                <h2 className="text-2xl font-bold">Regional Analysis</h2>
                <p className="text-gray-600 mt-2">Geographic distribution of sales and performance metrics</p>
            </div>

            {/* Regional Overview */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <div className="bg-white rounded-lg shadow p-6">
                    <h3 className="text-sm font-medium text-gray-600">Top Region</h3>
                    <p className="text-2xl font-bold mt-2">Asia</p>
                    <span className="text-gray-600 text-sm">37.5% of total sales</span>
                </div>
                <div className="bg-white rounded-lg shadow p-6">
                    <h3 className="text-sm font-medium text-gray-600">Highest Revenue</h3>
                    <p className="text-2xl font-bold mt-2">$93,000</p>
                    <span className="text-gray-600 text-sm">Asia region</span>
                </div>
                <div className="bg-white rounded-lg shadow p-6">
                    <h3 className="text-sm font-medium text-gray-600">Best Price Point</h3>
                    <p className="text-2xl font-bold mt-2">$19.99</p>
                    <span className="text-gray-600 text-sm">North America</span>
                </div>
            </div>

            {/* Sales by Region Chart */}
            <div className="bg-white rounded-lg shadow p-6 mb-8">
                <h3 className="text-lg font-medium mb-4">Regional Performance</h3>
                <div className="h-80">
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={data}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="region" />
                            <YAxis yAxisId="left" />
                            <YAxis yAxisId="right" orientation="right" />
                            <Tooltip />
                            <Legend />
                            <Bar yAxisId="left" dataKey="sales" fill="#3B82F6" name="Sales" />
                            <Bar yAxisId="right" dataKey="revenue" fill="#10B981" name="Revenue ($)" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>

            {/* Regional Pricing Comparison */}
            <div className="bg-white rounded-lg shadow p-6 mb-8">
                <h3 className="text-lg font-medium mb-4">Average Price by Region</h3>
                <div className="h-60">
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={data}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="region" />
                            <YAxis />
                            <Tooltip />
                            <Bar dataKey="avgPrice" fill="#6366F1" name="Average Price ($)" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>

            {/* Placeholder for More Features */}
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 flex items-start gap-3">
                <AlertCircle className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
                <div>
                    <h4 className="text-blue-700 font-medium">Coming Soon</h4>
                    <p className="text-blue-600 text-sm mt-1">
                        Regional market penetration analysis and localization recommendations are under development.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default RegionalAnalytics;